function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef, Ref, TextareaHTMLAttributes, ForwardRefRenderFunction, ChangeEvent } from 'react';
import cn from 'classnames';
import { useIsomorphicLayoutEffect } from '../../../hooks/useIsomorphicLayoutEffect';
import { useForkRef } from '../../../hooks/useForkRef';
import { useResizeObserver } from '../../../hooks/useResizeObserver';
import calculateNodeHeight from './calculateNodeHeight';
import getSizingData from './getSizingData';
require("./Textarea-Control.css");
var styles = {
  "Root": "Textarea-Control-module-Root_DL7"
};
const noop = () => {};
const TextareaControl = ({
  maxRows,
  minRows,
  onChange = noop,
  onHeightChange = noop,
  className,
  controlRef,
  maxCharactersLength,
  ...props
}) => {
  if (process.env.NODE_ENV !== 'production' && props.style) {
    if ('maxHeight' in props.style) {
      throw new Error('Использование `style.maxHeight` для <TextareaAutosize/> не поддерживается. Используйте `maxRows`.');
    }
    if ('minHeight' in props.style) {
      throw new Error('Использование `style.minHeight` для <TextareaAutosize/> не поддерживается. Используйте `minRows` .');
    }
  }
  const isControlled = props.value !== undefined;
  const libRef = useRef(null);
  const ref = useForkRef(libRef, controlRef);
  const heightRef = useRef(0);
  const resizeTextarea = () => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const node = libRef.current;
    const nodeSizingData = getSizingData(node);
    if (!nodeSizingData) {
      return;
    }
    const [height, rowHeight] = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows);
    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty('height', `${height}px`, 'important');
      onHeightChange(height, {
        rowHeight
      });
    }
  };
  const handleChange = event => {
    if (!isControlled) {
      resizeTextarea();
    }
    onChange(event);
  };
  const {
    width,
    height
  } = useResizeObserver({
    ref: libRef,
    debounceDelay: 1000
  });

  // срабатывает постоянно при изменение колонок или ввода, без задержки
  useIsomorphicLayoutEffect(resizeTextarea);
  // срабатывает при ресайзе с задержкой
  useIsomorphicLayoutEffect(resizeTextarea, [width, height]);
  return /*#__PURE__*/React.createElement("textarea", _extends({}, props, {
    maxLength: maxCharactersLength
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onChange: handleChange,
    ref: ref,
    className: cn(styles.Root, className)
  }));
};
export default TextareaControl;